if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      clearColorMediaFilter() {
        this.querySelectorAll('.product__media-item--color-hidden').forEach((el) => {
          el.classList.remove('product__media-item--color-hidden');
        });
        this.querySelectorAll('.thumbnail-list__item--color-hidden').forEach((el) => {
          el.classList.remove('thumbnail-list__item--color-hidden');
        });
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
      //  window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      filterMediaByColor(colorValue, sectionId) {
        if (!this.elements.viewer || !colorValue) return false;

        const colorNorm = colorValue.trim().toLowerCase();
        const colorIds = [];
        const allIds = [];

        this.setAttribute('data-color-media-filter', 'true');

        // Converts CamelCase filename (e.g. "SunsetRodeo") to spaced lowercase ("sunset rodeo")
        const colorFromFilename = (src) => {
          const match = (src || '').match(/\/([A-Za-z0-9]+)\.[^./?]+(?:\?|$)/);
          if (!match) return '';
          return match[1].replace(/([A-Z])/g, ' $1').trim().toLowerCase();
        };

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => {
          const alt = (el.dataset.mediaAlt || '').trim().toLowerCase();
          let show = false;
          let isAll = false;
          if (alt === 'all') {
            show = true;
            isAll = true;
          } else if (alt === colorNorm) {
            show = true;
          } else {
            const img = el.querySelector('img');
            const src = img ? (img.getAttribute('src') || '') : '';
            show = colorFromFilename(src) === colorNorm;
          }
          el.classList.toggle('product__media-item--color-hidden', !show);
          el.classList.remove('is-active');
          if (show) {
            const id = el.dataset.mediaId.replace(`${sectionId}-`, '');
            if (isAll) allIds.push(id);
            else colorIds.push(id);
          }
        });

        const visibleIds = [...colorIds, ...allIds];

        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((thumb) => {
            const alt = (thumb.dataset.mediaAlt || '').trim().toLowerCase();
            let show = alt === 'all' || alt === colorNorm;
            if (!show) {
              const img = thumb.querySelector('img');
              const src = img ? (img.getAttribute('src') || '') : '';
              show = colorFromFilename(src) === colorNorm;
            }
            thumb.classList.toggle('thumbnail-list__item--color-hidden', !show);
          });
        }

        if (visibleIds.length === 0) return false;

        this.setActiveMediaGroup(visibleIds, sectionId);

        const viewer = this.elements.viewer;
        if (viewer?.resetPages) viewer.resetPages();
        if (this.elements.thumbnails?.resetPages) this.elements.thumbnails.resetPages();

        return true;
      }

      setActiveMediaGroup(mediaIds, sectionId) {
        if (!mediaIds || mediaIds.length === 0) return;
        const viewer = this.elements.viewer;
        const mediaIdSet = new Set(mediaIds.map((id) => `${sectionId}-${id}`));

        viewer.querySelectorAll('[data-media-id]').forEach((el) => {
          if (mediaIdSet.has(el.dataset.mediaId)) {
            el.classList.remove('product__media-item--color-hidden');
          } else {
            el.classList.add('product__media-item--color-hidden');
            el.classList.remove('is-active');
          }
        });

        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((thumb) => {
            if (mediaIdSet.has(thumb.dataset.target)) {
              thumb.classList.remove('thumbnail-list__item--color-hidden');
            } else {
              thumb.classList.add('thumbnail-list__item--color-hidden');
            }
          });
        }

        viewer.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('is-active'));

        for (let i = mediaIds.length - 1; i >= 0; i--) {
          const el = viewer.querySelector(`[data-media-id="${sectionId}-${mediaIds[i]}"]`);
          if (el) el.parentElement.prepend(el);
        }

        if (this.elements.thumbnails) {
          for (let i = mediaIds.length - 1; i >= 0; i--) {
            const thumb = this.elements.thumbnails.querySelector(`[data-target="${sectionId}-${mediaIds[i]}"]`);
            if (thumb) thumb.parentElement.prepend(thumb);
          }
        }

        const firstEl = viewer.querySelector(`[data-media-id="${sectionId}-${mediaIds[0]}"]`);
        if (firstEl) {
          firstEl.classList.add('is-active');
          this.preventStickyHeader();
          window.setTimeout(() => {
            if (this.elements.thumbnails) {
              firstEl.parentElement.scrollTo({ left: 0 });
            }
            if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
              firstEl.scrollIntoView({ behavior: 'smooth' });
            }
          });
          this.playActiveMedia(firstEl);

          if (this.elements.thumbnails) {
            const firstThumb = this.elements.thumbnails.querySelector(`[data-target="${sectionId}-${mediaIds[0]}"]`);
            this.setActiveThumbnail(firstThumb);
            if (firstThumb) this.announceLiveRegion(firstEl, firstThumb.dataset.mediaPosition);
          }
        }

        const visibleCount = viewer.querySelectorAll('[data-media-id]:not(.product__media-item--color-hidden)').length;
        const counterTotal = this.querySelector('.slider-counter--total');
        if (counterTotal && visibleCount > 0) counterTotal.textContent = visibleCount;

        if (viewer.slider) viewer.resetPages();
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
